import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import logo from "../../assets/logo.jpeg";

/* ─── Icon component ──────────────────────────────────────────────────────── */
const Icon = ({ name }) => {
  const icons = {
    home: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
        <polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    package: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/>
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
        <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
        <line x1="12" y1="22.08" x2="12" y2="12"/>
      </svg>
    ),
    layers: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 2 7 12 12 22 7 12 2"/>
        <polyline points="2 17 12 22 22 17"/>
        <polyline points="2 12 12 17 22 12"/>
      </svg>
    ),
    "shopping-bag": (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 0 1-8 0"/>
      </svg>
    ),
    box: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
      </svg>
    ),
    briefcase: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
      </svg>
    ),
    settings: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="3"/>
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
      </svg>
    ),
    percent: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <line x1="19" y1="5" x2="5" y2="19"/>
        <circle cx="6.5" cy="6.5" r="2.5"/>
        <circle cx="17.5" cy="17.5" r="2.5"/>
      </svg>
    ),
    tag: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
        <line x1="7" y1="7" x2="7.01" y2="7"/>
      </svg>
    ),
    image: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
        <circle cx="8.5" cy="8.5" r="1.5"/>
        <polyline points="21 15 16 10 5 21"/>
      </svg>
    ),
    map: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/>
        <line x1="8" y1="2" x2="8" y2="18"/>
        <line x1="16" y1="6" x2="16" y2="22"/>
      </svg>
    ),
    "user-minus": (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <line x1="23" y1="11" x2="17" y2="11"/>
      </svg>
    ),
    bell: (
      <svg className="feather" xmlns="http://www.w3.org/2000/svg" width="21" height="21"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
        strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
    ),
  };

  return icons[name] || null;
};

/* ─── Chevron component ───────────────────────────────────────────────────── */
const Chevron = ({ open }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      marginLeft: "auto",
      flexShrink: 0,
      transition: "transform 0.25s ease",
      transform: open ? "rotate(90deg)" : "rotate(0deg)",
    }}
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ─── Static menu items ───────────────────────────────────────────────────── */
const ALL_MENU_ITEMS = [
  {
    key: "dashboard",
    title: "Dashboard",
    icon: "home",
    path: "/admin/dashboard",
    exact: true,
    hasSubmenu: false,
  },
   {
  key: "reports",
  title: "Reports",
  icon: "briefcase",
  path: "/admin/reports",
  exact: true,
  hasSubmenu: false,
},
    {
    key: "VendorMangement",
    title: "Vendor Management",
    icon: "package",
    path: "/admin/VendorMangement",
    exact: true,
    hasSubmenu: false,
  },
    {
    key: "category",
    title: "Category",
    icon: "layers",
    path: "/admin/category",
    exact: true,
    hasSubmenu: false,
  },

  {
    key: "products",
    title: "Product",
    icon: "shopping-bag",
    path: "/admin/products",
   exact: true,
    hasSubmenu: false,
 
  },
  {
    key: "orders",
    title: "Orders",
    icon: "box",
    path: "/admin/order/recevied",
    exact: true,
    hasSubmenu: false,
  },
   {
    key: "customer",
    title: "Customer",
    icon: "user-minus",
    path: "/admin/customer",
    exact: true,
    hasSubmenu: false,
  },
  // {
  //   key: "delivery",
  //   title: "Delivery Management",
  //   icon: "map",
  //   path: "/admin/location",
  //   exact: true,
  //   hasSubmenu: false,
  // },

  {
    key: "VendorReports",
    title: "Vendor Reports",
    icon: "box",
    path: "/admin/VendorReports",
    exact: true,
    hasSubmenu: false,
  },
 {
  key: "PayoutReport",
  title: "Payout Report",
  icon: "percent",
  path: "/admin/PayoutReport",
  exact: true,
  hasSubmenu: false,
},
  {
    key: "banner",
    title: "Banner",
    icon: "image",
    path: "/admin/banner",
    exact: true,
    hasSubmenu: false,
  },

   {
    key: "notification",
    title: "notification",
    icon: "bell",
    path: "/admin/notification",
    hasSubmenu: true,
    activePaths: ["/admin/notification/Users", "/admin/notification/vendor"],
    subItems: [
      { title: "Users notification",  path: "/admin/notification/Users",      exact: true },
      { title: "vendor notification", path: "/admin/notification/vendor", exact: true },
    ],
  },
  // {
  //   key: "settings",
  //   title: "Settings",
  //   icon: "settings",
  //   path: "/admin/settings",
  //   hasSubmenu: true,
  //   activePaths: ["/admin/settings/Users", "/admin/settings/Permission", "/admin/settings"],
  //   subItems: [
  //     { title: "Add Users",  path: "/admin/settings/Users",      exact: true },
  //     { title: "Permission", path: "/admin/settings/Permission", exact: true },
  //   ],
  // },
];

/* ─── Helper: derive which submenus should be open from pathname ──────────── */
const getOpenFromPath = (pathname) => {
  const state = {};
  ALL_MENU_ITEMS.forEach((item) => {
    if (!item.hasSubmenu) return;
    const paths = item.activePaths || [item.path];
    state[item.key] = paths.some((p) => pathname.startsWith(p));
  });
  return state;
};

/* ─── Sidebar ─────────────────────────────────────────────────────────────── */
const Sidebar = () => {
  const { pathname } = useLocation();

  // Static menu — no redux fetch needed
  const menuItems = ALL_MENU_ITEMS;

  const isActive = (path, exact = false) =>
    exact ? pathname === path : pathname.startsWith(path);

  const isSubmenuActive = (item) => {
    if (!item.hasSubmenu) return false;
    const paths = item.activePaths || [item.path];
    return paths.some((p) => pathname.startsWith(p));
  };

  const [openMenus, setOpenMenus] = useState(() => getOpenFromPath(pathname));
  const [hoveredKey, setHoveredKey] = useState(null);

  useEffect(() => {
    setOpenMenus((prev) => {
      const derived = getOpenFromPath(pathname);
      const next    = { ...prev };

      Object.keys(derived).forEach((key) => {
        next[key] = derived[key];
      });

      return next;
    });
  }, [pathname]);

  const toggle = (key) => {
    setOpenMenus((prev) => {
      const next = {};
      Object.keys(prev).forEach((k) => { next[k] = false; });
      next[key] = !prev[key];
      return next;
    });
  };

  const open = (key) => !!openMenus[key];

  const liClass = (item) => {
    const active = item.hasSubmenu
      ? isSubmenuActive(item)
      : isActive(item.path, item.exact);

    return `sidebar-list${
      active || hoveredKey === item.key || open(item.key) ? " sp-active" : ""
    }`;
  };

  const submenuStyle = (key) => ({
    listStyle:  "none",
    padding:    0,
    margin:     0,
    overflow:   "hidden",
    maxHeight:  open(key) ? "300px" : "0",
    transition: "max-height 0.28s ease",
  });

  return (
    <div className="sidebar-wrapper textCenter">
      <div>
        <div className="logo-wrapper">
          <a>
            <div className="img-fluid for-light logoText">
              <img src={logo} className="logoimg" alt="" />
            </div>
            <div className="img-fluid for-dark logoText">
              <img src={logo} className="logoimg" alt="" />
            </div>
          </a>
          <div className="back-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18" height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ef4444"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="15" y1="9" x2="9" y2="15" />
              <line x1="9" y1="9" x2="15" y2="15" />
            </svg>
          </div>
        </div>

        <div className="logo-icon-wrapper">
          <a href="index.html">
            <img
              className="img-fluid"
              src="../assets/images/logo-icon.png"
              alt=""
            />
          </a>
        </div>

        <nav className="sidebar-main">
          <div id="sidebar-menu">
            <SimpleBar
              id="simple-bar"
              autoHide={true}
              style={{ maxHeight: "calc(100vh - 100px)" }}
            >
              <ul className="sidebar-links">
                {menuItems.map((item) => (
                  <li
                    key={item.key}
                    className={liClass(item)}
                    onMouseEnter={() => setHoveredKey(item.key)}
                    onMouseLeave={() => setHoveredKey(null)}
                  >
                    {!item.hasSubmenu ? (
                      <Link
                        className={`sidebar-link sidebar-title link-nav${
                          isActive(item.path, item.exact) ? " active" : ""
                        }`}
                        to={item.path}
                      >
                        <Icon name={item.icon} />
                        <span>{item.title}</span>
                      </Link>
                    ) : (
                      <>
                        
                     <a     className={`sidebar-link sidebar-title${
                            isSubmenuActive(item) ? " active" : ""
                          }`}
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            toggle(item.key);
                          }}
                        >
                          <Icon name={item.icon} />
                          <span>{item.title}</span>
                          <Chevron open={open(item.key)} />
                        </a>

                        <ul
                          className="sidebar-submenu"
                          style={submenuStyle(item.key)}
                        >
                          {item.subItems.map((subItem, idx) => (
                            <li className="submenulist" key={idx}>
                              <Link
                                className={
                                  isActive(subItem.path, subItem.exact)
                                    ? "active"
                                    : ""
                                }
                                to={subItem.path}
                              >
                                - {subItem.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </SimpleBar>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;